<template>
  <v-container fluid class="pa-5">
    <v-layout align-center justify-center my-2>
      <v-flex md9 class="headline">
        Flujo de ivr
      </v-flex>
      <v-flex md3>
        <v-btn class="k-orange-linear white--text" block large @click="ivrDialog = true">
          Agregar plantilla ivr
        </v-btn>
      </v-flex>
    </v-layout>
    <data-table
      ref="ivrTemplatesDialog"
      url="ivr_templates"
      :search="search"
      :filters="filters"
      @items-reload="ivrTemplates = $event">
      <template slot="content" v-for="(item, i) in ivrTemplates">
        <v-list-tile
          :key="`ivrTemplate-${item.id}`"
          @click="editTemplate(item)"
          avatar>
          <v-list-tile-avatar>
            <v-icon class="k-orange-linear-text" large>
              fas fa-robot
            </v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <strong>
                {{ item.name }}
              </strong>
            </v-list-tile-title>
          </v-list-tile-content>
          <v-spacer></v-spacer>
          <v-chip
            small
            :class="{'green': item.status_id === 1, 'red': item.status_id === 2}"
            class="white--text">
            <v-icon class="pr-2 x-small-icon" v-if="item.status_id === 1">fas fa-check</v-icon>
            <v-icon class="pr-2 x-small-icon" v-if="item.status_id === 2">fas fa-times</v-icon>
            {{ item.status_id === 1 ? 'Activo' : 'Inactivo' }}
          </v-chip>
          <v-list-tile-action>
            <v-menu bottom offset-y @click.native.stop>
              <v-btn slot="activator" color="grey darken-2" small flat fab>
                <v-icon>fas fa-ellipsis-v</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="changeStatus(item)">
                  <v-list-tile-title>
                    {{ item.status_id === 1 ? 'Desactivar' : 'Activar' }}
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="editTemplate(item)">
                  <v-list-tile-title>Editar</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="testTemplate(item)">
                  <v-list-tile-title>Probar</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider
          v-if="i !== ivrTemplates.length - 1"
          :key="`divider${i}`"/>
      </template>
    </data-table>
    <ivr-dialog
      :show="ivrDialog"
      title="Crear plantilla de ivr"
      :newIvr="newIvr"
      @save="save"
      @close="ivrDialog = false"/>
    <change-status
      :show="changeStatusDialog"
      :ivr-template="ivrTemplate"
      @updated="ivrTemplateUpdated"
      @close="changeStatusDialog = false"/>
   <test-template-dialog
      :show="testTemplateDialog"
      :template-id="testTemplateId"
      :channel="3"
      @close="testTemplateDialog = false" />
  </v-container>
</template>

<script>
import DataTable from '@/components/global/DataTable2';
import ChangeStatus from '@/components/ivr_v2/ChangeStatus';
import IvrDialog from '@/components/ivr_v2/IvrDialog';
import TestTemplateDialog from '@/components/Templates/TestDialog';

export default {
  components: {
    DataTable,
    IvrDialog,
    ChangeStatus,
    TestTemplateDialog,
  },
  data() {
    return {
      showChecker: false,
      ivrDialog: false,
      changeStatusDialog: false,
      testTemplateDialog: false,
      testTemplateId: 0,
      newIvr: true,
      ivrTemplate: {},
      search: '',
      filters: {
        status: '',
      },
      ivrTemplates: [],
      states: [
        {
          text: 'Estatus',
          value: '',
        },
        {
          text: 'Activo',
          value: 1,
        },
        {
          text: 'Inactivo',
          value: 2,
        },
      ],
    };
  },
  created() {
    // this.axios.get('check_release', { params: { name: 'new_ivr' } })
    //   .then(({ data }) => {
    //     this.newIvr = data.is_active;
    //   })
    //   .catch(() => {
    //     this.newIvr = false;
    //   });
  },
  methods: {
    editTemplate(ivrTemplate) {
      this.$router.push(`/ivr_v2/detail/${ivrTemplate.id}`);
    },
    testTemplate(template) {
      this.testTemplateId = template.id;
      this.testTemplateDialog = true;
    },
    changeStatus(item) {
      this.ivrTemplate = {
        ...item,
      };
      this.changeStatusDialog = true;
    },
    ivrTemplateUpdated(ivrTemplate) {
      const index = this.ivrTemplates.findIndex(item => item.id === ivrTemplate.id);
      this.$set(this.ivrTemplates, index, ivrTemplate);
      this.ivrDialog = false;
    },
    save(form) {
      this.axios.post('ivr_templates', form).then(({ data }) => {
        this.$router.push(`ivr_v2/detail/${data.id}`);
      }).catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ivr_v2/Index.vue